module.exports = __webpack_public_path__ + "img/KSC07259.adb7ecad.jpg";